// Product category constants shared across PreQualification components

// Category-based scripts - one-liners for blue box display
export const categoryOneLiners: {[key: string]: string} = {
    IUL: 'An IUL builds tax-efficient retirement savings while keeping permanent coverage in place—it grows with market potential but protects against losses.',
    TERM: "Term life gives you the most protection for your dollar—it's simple, affordable, and locks in coverage for the years your family needs it most.",
    FEXP: 'Whole Life coverage is a simple, permanent life policy that ensures that you will pass down a legacy to your loved ones.',
    VUL: '',
    ANNUITY:
        'An indexed annuity lets you earn interest linked to the market while protecting your principal from losses, and there is no cost of insurance.',
    ADB: 'Accidental Death coverage gives you extra protection at a fraction of the cost—it pays significantly more for loss of life from unexpected events.',
};

// Full scripts for hover display
export const categoryFullScripts: {[key: string]: string} = {
    IUL: "An IUL builds tax-efficient retirement income while keeping permanent coverage in place—it grows with market potential but protects against losses. Let's run a customized quote to see what you qualify for and what your protection and cash value can look like—is XX the right monthly savings amount for you?",
    TERM: "Term life gives you the most protection for your dollar—it's simple, affordable, and locks in coverage for the years your family needs it most. Let's see what your best rate looks like—can I confirm this comfortable monthly amount for you?",
    FEXP: "Whole Life coverage is a simple, guaranteed-for-life plan that ensures that you will pass down a legacy to your loved ones. There's no underwriting, the coverage is guaranteed, and the premiums never increase. I can run a quick quote for you to see what rates you may qualify for.",
    VUL: '',
    ANNUITY:
        "Based on what you've shared, it sounds like you want to maximize your retirement value. An indexed annuity could be a strong fit — it lets you earn interest linked to the market while protecting your principal from losses. Since it's purely focused on retirement, there is no cost of insurance. We have annuities specialists in house, if you could hold briefly we can run some options to see how we can help you maximize your retirement.",
    ADB: 'Accidental Death coverage gives you extra protection at a fraction of the cost—it pays significantly more for an unexpected loss of life from unexpected events.',
};

// Fallback triggers for each product type (used in both components)
export const productFallbackTriggers: {[key: string]: string} = {
    IUL: 'Wants flexible access to cash before retirement • Prefers market-linked upside with protections • Has protection needs',
    Term: 'Prefers simple, lowest-cost protection • Wants the largest death benefit per dollar • Discomfort with complexity of retirement products',
    'Whole Life':
        'Wants permanent coverage • Cost sensitive • Needs to cover funeral/final costs • Health/Underwriting challenges',
    Annuity:
        'Retirement-focused • Wants guaranteed returns/income • Wants highest retirement value • Protection is lower priority • Hesitant about IUL policy fees',
    ADB: 'Health/underwriting challenges • Wants protection at the lowest possible cost • Ultra price sensitive',
    VUL: '[VUL fallback triggers placeholder]',
};

// Primary product scripts (used in Prequalification.tsx)
export const productScriptPrimary = (product: string): string => {
    switch (product) {
        case 'IUL':
            return categoryFullScripts['IUL'];
        case 'Term':
            return categoryFullScripts['TERM'];
        case 'Whole Life':
            return categoryFullScripts['FEXP'];
        case 'Annuity':
            return categoryFullScripts['ANNUITY'];
        case 'ADB':
            return categoryFullScripts['ADB'];
        default:
            return '';
    }
};

// Fallback product scripts
export const productScriptFallback = (product: string): string => {
    switch (product) {
        case 'IUL':
            return "If you'd like protection that builds value over time, an IUL lets you grow cash value you can access later while keeping lifetime coverage. Let's pull a quick custom quote so you can see how much cash we can help you build and how much coverage you qualify for— is XX still a good monthly savings amount for you?";
        case 'Term':
            return "If keeping things simple and cost-efficient fits better, term gives you the biggest coverage for the lowest payment—you're fully protected without overcommitting. You can always add permanent or cash value policies later on. Let me run a quick quote and show you how much coverage you can qualify for.";
        case 'Whole Life':
            return "Whole Life coverage is a simple, guaranteed-for-life plan that ensures that you will pass down a legacy to your loved ones. There's no underwriting, the coverage is guaranteed, and the premiums never increase. I can run a quick quote for you to see what rates you may qualify for.";
        case 'Annuity':
            return "Based on what you've shared, it sounds like you want to maximize your retirement value. An indexed annuity could be a strong fit — it lets you earn interest linked to the market while protecting your principal from losses. Since it's purely focused on retirement, there is no cost of insurance. We have annuities specialists in house, if you could hold briefly we can run some options to see how we can help you maximize your retirement.";
        case 'ADB':
            return 'Accidental Death coverage gives you extra protection at a fraction of the cost—it pays significantly more for an unexpected events like accidents. We have in-house specialists who can help you run a quote, if you wait a few moments, I can transfer you to them and we can share some options for you.';
        default:
            return '';
    }
};

// Get fallback triggers with the correct formatting
export const getProductFallbackTriggers = (product: string): string => {
    // Remove the bullet formatting as it's added in the component
    const triggers = productFallbackTriggers[product];
    if (triggers) {
        return triggers;
    }

    // For backward compatibility with the old format
    switch (product) {
        case 'IUL':
            return '• Wants flexible access to cash before retirement • Prefers market‑linked upside with protections • Has protection needs';
        case 'Term':
            return '• Prefers simple, lowest‑cost protection • Wants the largest death benefit per dollar • Discomfort with complexity of retirement products';
        case 'Whole Life':
            return '• Wants permanent coverage • Cost sensitive • Needs to cover funeral/final costs • Health/Underwriting challenges';
        case 'Annuity':
            return '• Wants guaranteed returns/income • Wants highest retirement value • Protection is lower priority • Hesitant about IUL policy fees';
        case 'ADB':
            return '• Health/underwriting challenges • Wants protection at the lowest possible cost • Ultra price sensitive';
        default:
            return '';
    }
};
